import React, {useContext, useMemo} from 'react';
import dayjs from "dayjs";
import LogTemplate from "./LogTemplate";
import {AuthContext} from "../../shared/contexts/authContext";
import GoToUserInfoButton from "../../shared/components/buttons/GoToUserInfoButton";
import {useItemKrTextData} from "../probability/useItemData";
import IsLoading from "../../shared/components/IsLoading";
import ErrorPage from "../../shared/components/ErrorPage";
import {getGoodsLogColumns} from "./columns/goodsLogColumns";

const SpecialBlockLog = () => {
    const { currentUser } = useContext(AuthContext);
    const { data: krItemTextData, isLoading, error } = useItemKrTextData();

    const searchParams = useMemo(() => ({
        begin: dayjs().subtract(1, "week").startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        end: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
        logType: 'special_block_log',
        isUnix: false,
    }), []);

    const paramTypeList = [
        {label: 'PID', value: 'pId'},
        {label: '아이템 ID', value: 'itemId'},
    ];

    const columns = useMemo(() => ([
        {
            title: 'PID',
            dataIndex: 'pid',
            search: true,
        },
        {
            title: '유저 키',
            dataIndex: 'userKey',
            search: true,
        },
        {
            title: '유저 닉네임',
            dataIndex: 'name',
            search: true,
        },
        ...getGoodsLogColumns(krItemTextData, currentUser, 7),
        {
            title: '획득 타입',
            dataIndex: 'gainType',
        },
        {
            title: '타겟 아이템',
            dataIndex: 'targetId'
        },
        {
            title: '잔여시간(분)',
            dataIndex: 'remain',
            render: (minutes) => {
                if (minutes > 0) {
                    const h = Math.floor(minutes / 60);
                    const m = minutes % 60;
                    return `${h}시간 ${m}분`;
                }
                return '0시간 0분';
            },
        },
        {
            title: '유저 정보',
            dataIndex: 'pid',
            render: (pid) => <GoToUserInfoButton pid={pid} />,
        },
    ]), [krItemTextData, currentUser]);

    if (isLoading) return <IsLoading />;
    if (error) return <ErrorPage error={error} />;

    return (
        <LogTemplate
            columns={columns}
            defaultSearchParams={searchParams}
            paramTypeList={paramTypeList}
            routerUrl={'/logs'}
        />
    );
};

export default SpecialBlockLog;